import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import GiftIcon from "@material-ui/icons/CardGiftcardOutlined";
import WarningIcon from "@material-ui/icons/ReportProblemOutlined";
import ErrorIcon from "@material-ui/icons/ErrorOutlineOutlined";
import CancelIcon from "@material-ui/icons/CancelOutlined";
import { IconButton } from "@material-ui/core";
import Tooltip from "./StyledToolTip";

const styles = theme => ({
  paper: {
    padding: 12,
    display: "flex"
  },
  icon: {
    fontSize: 20
  },
  link: {
    textDecoration: "underline",
    fontWeight: 600,
    fontSize: theme.textFontSize,
    cursor: "pointer",
    minWidth:"max-content",
    padding:"0 4px"
  },
  messageContainer: {
    fontSize: theme.textFontSize,
    overflow: "hidden",   
    display:"flex",
    flexGrow:1
  },
  message:{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  iconButton: {
    padding: 0
  },
  info:{
    color: theme.infoTextColor,
    backgroundColor:theme.infoBGColor,
    '& *':{
      color: theme.infoTextColor,
    }
  },
  warning:{
    color: theme.warningTextColor,
    backgroundColor:theme.warningBGColor,
    '& *':{
      color: theme.warningTextColor,
    }
  },
  error:{
    color: theme.errorTextColor,
    backgroundColor:theme.errorBGColor,
    '& *':{
      color: theme.errorTextColor,
    }
  },
  gridItem:{
    flexGrow:0
  }
});


const getNotificationConfig = ({notificationType, classes}) => {
  switch (notificationType) {
    case 'Info':  return {
                            Icon: GiftIcon,
                            className: classes.info
                          };
    case 'Warning':  return {
                              Icon: WarningIcon,
                              className: classes.warning
                            };
    case 'Error':  return {
                              Icon: ErrorIcon,
                              className: classes.error
                            };
    default: return {
                              Icon: null,
                              className: ""
                            
                     }
  }
}

const openLink = (linkUrl) => {
  if(linkUrl){
    window.open(linkUrl, "_blank")
  } else {
    window.location.reload();
  }
}

const NotificationBanner = props => {
  const { classes, data, onClose } = props;
  const { Icon, className } =  getNotificationConfig({notificationType: data.type, classes})

  return (
      <Paper elevation={0} square className={`${classes.paper} ${className}`}>
        <Grid
          container
          wrap="nowrap"
          spacing={8}
          alignItems="center"
		      justify="flex-start"
        >
          <Grid item classes={{item: classes.gridItem}} > 
            {Icon && <Icon className={classes.icon} id={`${data.type}_icon`}/>}
          </Grid>
          
            <Grid item classes={{item: classes.messageContainer}} >
              <Tooltip title={data.message}><div className={classes.message} id="notificationMessage">{ data.message}</div></Tooltip>
              { data.linkLabel && (
                  <div className={classes.link} onClick={() => openLink(data.linkUrl)} id="notificationlink">
                    { data.linkLabel }
                  </div>
                )}                 
            </Grid>     

          { data.isClosable && (
                  <Grid item classes={{item: classes.gridItem}}>
                    <IconButton
                      aria-label="Close"
                      className={classes.iconButton}
                      onClick={onClose}
                    >
                      <CancelIcon className={classes.icon} id="Cancel_icon"/>
                    </IconButton>
                  </Grid>
            )}
        </Grid>
       
      <Divider/>
    </Paper>
  );
};
export default withStyles(styles)(NotificationBanner);